// Vendor
import * as React from 'react';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';

// Styles
import styles from './styles.module.css';

/**
 * @name SlideReveal
 * @description Slide reveal image
 */
const SlideReveal: React.FC = (props) => {
  const { children } = props;

  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  const classesOverlay = classnames(styles.overlay, {
    [styles.reveal]: inView
  });

  return (
    <div className="relative" ref={ref}>
      <div className={classesOverlay}></div>
      {children}
    </div>
  );
};

export { SlideReveal };
